import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutEdiErrorCodeLookup extends Layout {
}
